import { createRouter, createWebHistory } from 'vue-router';

const routes = [
    {
        path: '/',
        redirect: {
            name: 'home'
        }
    },
    {
        path: '/home',
        name: 'home',
        component: () => import('../views/home'),
        meta: {
            title: '首页'
        }
    },
    {
        path: '/zhipaiyun',
        name: 'zhipaiyun',
        component: () => import('../views/zhipaiyun'),
        meta: {
            title: '智培云平台'
        }
    },
    {
        path: '/shuzhisandpan',
        name: 'shuzhisandpan',
        component: () => import('../views/shuzhisandpan'),
        meta: {
            title: '数字沙盘教学系统'
        }
    },
    {
        path: '/vrtraining',
        name: 'vrtraining',
        component: () => import('../views/vrtraining'),
        meta: {
            title: 'VR培训系统'
        }
    },
    {
        path: '/mrshubosystem',
        name: 'mrshubosystem',
        component: () => import('../views/mrshubosystem'),
        meta: {
            title: 'MR数播系统'
        }
    },
    {
        path: '/naked3d',
        name: 'naked3d',
        component: () => import('../views/naked3d'),
        meta: {
            title: '裸眼3D模拟系统'
        }
    },
    {
        path: '/qingjinghua',
        name: 'qingjinghua',
        component: () => import('../views/qingjinghua'),
        meta: {
            title: '情景化培训系统'
        }
    },
    {
        path: '/faultsimulator',
        name: 'faultsimulator',
        component: () => import('../views/faultsimulator'),
        meta: {
            title: '仿真故障模拟器'
        }
    },
    {
        path: '/remoteoperation',
        name: 'remoteoperation',
        component: () => import('../views/remoteoperation'),
        meta: {
            title: '远程设备运维系统'
        }
    },
    {
        path: '/digitalhall',
        name: 'digitalhall',
        component: () => import('../views/digitalhall'),
        meta: {
            title: '数字化展厅'
        }
    },
    {
        path: '/meikuangcaijuequanyuruanshengzhonghe',
        name: 'meikuangcaijuequanyuruanshengzhonghe',
        component: () => import('../views/meikuangcaijuequanyuruanshengzhonghe'),
        meta: {
            title: '煤矿采掘全域孪生综合解决方案'
        }
    },
    {
        path: '/shuzishanpan',
        name: 'shuzishanpan',
        component: () => import('../views/shuzishanpan'),
        meta: {
            title: '数字沙盘推演系统'
        }
    },
    {
        path: '/bianbozhinengjianceheyujing',
        name: 'bianbozhinengjianceheyujing',
        component: () => import('../views/bianbozhinengjianceheyujing'),
        meta: {
            title: '边波智能监测和预警系统'
        }
    },
    {
        path: '/duoyuanjianceshuju',
        name: 'duoyuanjianceshuju',
        component: () => import('../views/duoyuanjianceshuju'),
        meta: {
            title: '多源监测数据"预訾树"系统'
        }
    },
    {
        path: '/fenbushiguanqianjiance',
        name: 'fenbushiguanqianjiance',
        component: () => import('../views/fenbushiguanqianjiance'),
        meta: {
            title: '分布式光纤监测与智能预警'
        }
    },
    {
        path: '/wasichoucaizhinengjiankong',
        name: 'wasichoucaizhinengjiankong',
        component: () => import('../views/wasichoucaizhinengjiankong'),
        meta: {
            title: '瓦斯抽采智能监控平台'
        }
    },
    {
        path: '/ARranqizhinengxunjian',
        name: 'ARranqizhinengxunjian',
        component: () => import('../views/ARranqizhinengxunjian'),
        meta: {
            title: 'AR燃气智能巡检系统'
        }
    },
    {
        path: '/hangyeanli',
        name: 'hangyeanli',
        component: () => import('../views/hangyeanli'),
        meta: {
            title: '行业案例'
        }
    },
    {
        path: '/guanyuwomen',
        name: 'guanyuwomen',
        component: () => import('../views/guanyuwomen'),
        meta: {
            title: '关于我们'
        }
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

// Simplified beforeEach - only handle title setting
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

router.afterEach(() => {
    // 滚动到页面顶部
    window.scrollTo(0, 0);
});

export default router;